import { useCallback, useEffect, useState } from 'react';
import { Crown, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { OwnerLogin } from '../components/platform/OwnerLogin';
import { LicenseCard } from '../components/platform/LicenseCard';
import { AddonsCard } from '../components/platform/AddonsCard';
import { StorageCard } from '../components/platform/StorageCard';
import { MigrationCard } from '../components/platform/MigrationCard';
import { PerfPanel } from '../components/platform/perf/PerfPanel';
import { ownerApi } from '../components/platform/ownerApi';
import { SetupPanel } from '../components/platform/SetupPanel';
import { FirstAdminCard } from '../components/platform/FirstAdminCard';

export default function PlatformOwnerPage() {
  const [token, setToken] = useState(localStorage.getItem('po_token'));
  const [data, setData] = useState(null);

  const [view, setView] = useState('manage');
  const [locked, setLocked] = useState(false);
  const logout = useCallback(() => { localStorage.removeItem('po_token'); setToken(null); setData(null); }, []);
  useEffect(() => {
    if (!token) return;
    ownerApi.get('/platform-owner/overview').then(r => { setLocked(false); setData(r.data); }).catch(e => {
      if (e.response?.data?.code === 'SETUP_LOCKED') setLocked(true); else if (e.response?.status === 401) logout();
    });
  }, [token, logout]);
  const unlocked = useCallback(() => { setLocked(false); logout(); }, [logout]);

  if (!token) return <OwnerLogin onLogin={(t) => { localStorage.setItem('po_token', t); setToken(t); }} />;

  return (
    <div className="min-h-screen bg-slate-50" data-testid="owner-panel">
      <header className="bg-slate-950 px-6 py-5 text-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500"><Crown className="h-5 w-5" /></span>
            <div><p className="font-bold">Platform Sahibi Paneli</p><p className="text-xs text-slate-400">Lisans, eklenti ve depolama yönetimi</p></div>
          </div>
          <nav className="ml-auto mr-4 flex gap-1 rounded-lg bg-white/5 p-1">
            {[['manage', 'Yönetim'], ['perf', 'Sistem Performansı']].map(([k, l]) => (
              <button key={k} type="button" onClick={() => setView(k)} className={`rounded-md px-3 py-1.5 text-sm transition-colors ${view === k ? 'bg-white text-slate-900' : 'text-slate-300 hover:text-white'}`} data-testid={`owner-nav-${k}`}>{l}</button>
            ))}
          </nav>
          <Button variant="ghost" className="text-slate-300 hover:bg-white/10 hover:text-white" onClick={logout} data-testid="owner-logout"><LogOut className="mr-2 h-4 w-4" />Çıkış</Button>
        </div>
      </header>
      {locked ? <SetupPanel onUnlocked={unlocked} /> : view === 'perf' ? <main className="mx-auto max-w-7xl px-6 py-8"><PerfPanel /></main> : !data ? <div className="p-12 text-center text-slate-500">Yükleniyor...</div> : (
        <main className="mx-auto grid max-w-6xl gap-6 px-6 py-10 lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-2">
            <LicenseCard license={data.license} onSaved={setData} />
            <AddonsCard addons={data.addons} onSaved={setData} />
          </div>
          <div className="space-y-6"><StorageCard /><FirstAdminCard /></div>
          <MigrationCard />
        </main>
      )}
    </div>
  );
}
